import React, { useState, useContext } from "react";
import { Card, Form, Button } from "react-bootstrap";
import { Link, useNavigate, useLocation } from "react-router-dom";
import Policy from "./Policy";
import { AuthContext } from "../context/AuthContext";
import axios from "axios";

const Signup = () => {
    const location = useLocation();
    const initialEmail = location.state?.email || '';
    const [passwordShown, setPasswordShown] = useState(false);
    const [confirmPasswordShown, setConfirmPasswordShown] = useState(false);
    const [name, setName] = useState('');
    const [phone_number, setPhone] = useState('');
    const [email, setEmail] = useState(initialEmail);
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [trustDevice, setTrustDevice] = useState(false);
    const [errors, setErrors] = useState({ name: '', email: '', phone_number: '', password: '', confirmPassword: '', invalid: '' });
    const [showPolicy, setShowPolicy] = useState(false);
    const { setAuth } = useContext(AuthContext);
    const [loading, setLoading] = useState(false); // Loading state
    const navigate = useNavigate();

    const togglePasswordVisibility = () => {
        setPasswordShown(!passwordShown);
    };

    const toggleConfirmPasswordVisibility = () => {
        setConfirmPasswordShown(!confirmPasswordShown);
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        setErrors({ name: '', email: '', phone_number: '', password: '', confirmPassword: '', invalid: '' });
    
        // Check required fields
        if (!name) {
            setErrors((prevErrors) => ({ ...prevErrors, name: 'Name is required.' }));
            return;
        }
        if (!email) {
            setErrors((prevErrors) => ({ ...prevErrors, email: 'Email is required.' }));
            return;
        }
        if (!phone_number) {
            setErrors((prevErrors) => ({ ...prevErrors, phone_number: 'Phone number is required.' }));
            return;
        }
        if (!password) {
            setErrors((prevErrors) => ({ ...prevErrors, password: 'Password is required.' }));
            return;
        }
        if (!confirmPassword) {
            setErrors((prevErrors) => ({ ...prevErrors, confirmPassword: 'Confirm password is required.' }));
            return;
        }
        if (password !== confirmPassword) {
            setErrors((prevErrors) => ({ ...prevErrors, confirmPassword: 'Passwords do not match.' }));
            return;
        }

        setLoading(true); // Set loading to true when API call starts
    
        try {
            const response = await axios.post(`${process.env.REACT_APP_API_URL}/signup`, {
                name,
                email,
                phone_number,
                password,
                account_status:'signed_up'
            });

            const data = response.data;

            console.log(data);
            console.log(data.message);
            
    
            if (data.message === "User created successfully") {
                navigate('/pricing-plans', { state: { email } });

                const response = await axios.post(`${process.env.REACT_APP_API_URL}/login`, {
                    email,
                    password
                }, {
                    headers: {
                        'Content-Type': 'application/json'
                    }
                });
        
                const data = response.data;
        
                if (response.status === 200 && data.accessToken) {
                    let accessToken = data.accessToken;
                    let refreshToken = data.refreshToken;
                    let userId = data.userId;

                    const response = await axios.get(`${process.env.REACT_APP_API_URL}/user/${data.userId}`, {
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${data.accessToken}`,
                        },
                    });

                    let userName = response.data.name;

                    localStorage.setItem('accessToken', accessToken);
                    localStorage.setItem('refreshToken', refreshToken);
                    localStorage.setItem('userId', userId);
                    localStorage.setItem('userName', userName);
                    setAuth({ accessToken, refreshToken, userId, userName });
                } else {
                    setErrors({ ...errors, invalid: data.message || 'Invalid email or password.' });
                }
            } else {
                // Handle case where API response indicates invalid credentials
                setErrors({ ...errors, invalid: data.message || 'Error during sign-up.' });
            }
        } catch (error) {
            // Check if the error response exists and contains a message
            if (error.response && error.response.data) {
                setErrors({ ...errors, invalid: error.response.data.message || 'Failed to sign up. Please try again later.' });
            } else {
                setErrors({ ...errors, invalid: 'Failed to sign up. Please try again later.' });
            }
        } finally {
            setLoading(false); // Reset loading state after API call
        }
    };

    const handleShowPolicy = () => {
        setShowPolicy(true);
    };

    const handleHidePolicy = () => {
        setShowPolicy(false);
    };

    return (
        <div className="login-container">
            {showPolicy ? (
                <Policy handleClose={handleHidePolicy} />
            ) : (
                <Card className="signup-card gradient-border">
                    <Card.Body>
                        <div className="text-center mb-4 mt-2">
                            <img src={`${process.env.PUBLIC_URL}/images/No Doji 1.svg`} className="App-logo" alt="logo" />
                        </div>
                        <Form onSubmit={handleSubmit}>
                            <Form.Group controlId="formBasicEmail" className="floating-label-group">
                                <Form.Control
                                    type="text"
                                    className="form-input"
                                    placeholder=" "
                                    value={name}
                                    onChange={(e) => setName(e.target.value.toLowerCase())}
                                />
                                <label className={name ? 'floating-label float' : 'floating-label'}>Name</label>
                            </Form.Group>
                            {errors.name && <div className="text-danger mt-1">{errors.name}</div>}
                            
                            <Form.Group controlId="formBasicEmail" className="mt-3 floating-label-group">
                                <Form.Control
                                    type="email"
                                    className="form-input"
                                    placeholder=" "
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value.toLowerCase())}
                                />
                                <label className={email ? 'floating-label float' : 'floating-label'}>Email</label>
                            </Form.Group>
                            {errors.email && <div className="text-danger mt-1">{errors.email}</div>}

                            <Form.Group controlId="formBasicEmail" className="mt-3 floating-label-group">
                                <Form.Control
                                    type="text"
                                    className="form-input"
                                    placeholder=" "
                                    value={phone_number}
                                    onChange={(e) => setPhone(e.target.value.toLowerCase())}
                                />
                                <label className={phone_number ? 'floating-label float' : 'floating-label'}>Phone Number</label>
                            </Form.Group>
                            {errors.phone_number && <div className="text-danger mt-1">{errors.phone_number}</div>}

                            <Form.Group controlId="formBasicPassword" className="mt-3 floating-label-group">
                                <div className="password-wrapper">
                                    <Form.Control
                                        type={passwordShown ? 'text' : 'password'}
                                        className="form-input"
                                        placeholder=" "
                                        value={password}
                                        onChange={(e) => setPassword(e.target.value)}
                                    />
                                    <label className={password ? 'floating-label float' : 'floating-label'}>Password</label>
                                    <span className="toggle-password" onClick={togglePasswordVisibility}>
                                        {passwordShown ? <img src={`${process.env.PUBLIC_URL}/images/eye_visible.png`} alt="eye" /> : <img src={`${process.env.PUBLIC_URL}/images/eye_hide.png`} alt="eye" />}
                                    </span>
                                </div>
                            </Form.Group>
                            {errors.password && <div className="text-danger mt-1">{errors.password}</div>}

                            <Form.Group controlId="formBasicPassword" className="mt-3 floating-label-group">
                                <div className="password-wrapper">
                                    <Form.Control
                                        type={confirmPasswordShown ? 'text' : 'password'}
                                        className="form-input"
                                        placeholder=" "
                                        value={confirmPassword}
                                        onChange={(e) => setConfirmPassword(e.target.value)}
                                    />
                                    <label className={confirmPassword ? 'floating-label float' : 'floating-label'}>Confirm Password</label>
                                    <span className="toggle-password" onClick={toggleConfirmPasswordVisibility}>
                                        {confirmPasswordShown ? <img src={`${process.env.PUBLIC_URL}/images/eye_visible.png`} alt="eye" /> : <img src={`${process.env.PUBLIC_URL}/images/eye_hide.png`} alt="eye" />}
                                    </span>
                                </div>
                            </Form.Group>
                            {errors.confirmPassword && <div className="text-danger mt-1">{errors.confirmPassword}</div>}
                            
                            <div>
                                <Button 
                                    variant="primary" 
                                    type="submit" 
                                    className="mt-3 w-100 p-2 theme-btn"
                                    disabled={loading} // Disable button if loading
                                >
                                    {loading ? "Signing Up..." : "Sign up"} {/* Change button text based on loading state */}
                                </Button>
                                <div className="text-center mt-3">
                                    <span className="privacy-policy" role="button" onClick={handleShowPolicy}>Privacy policy</span>
                                    <div className="text-center mt-3">
                                        <Link to="/" className="forgot-password"> <span style={{color: "#FFFFFF"}}>Already have an account?</span> Log in</Link>
                                    </div>
                                </div>
                            </div>
                        </Form>
                    </Card.Body>
                </Card>
            )}
        </div>
    );
};

export default Signup;
